const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  signature: state => state.user.signature,
  name: state => state.user.name,
  email: state => state.user.email,
  userId: state => state.user.userId,
  emailVerified: state => state.user.emailVerified,
  country: state => state.user.country,
  receiveNews: state => state.user.receiveNews,
  receivePost: state => state.user.receivePost,
  receiveRecommendFriend: state => state.user.receiveRecommendFriend,
  receiveChatReminder: state => state.user.receiveChatReminder,
  receiveComment: state => state.user.receiveComment,
  receiveActivity: state => state.user.receiveActivity,
  receiveLike: state => state.user.receiveLike,
  receiveGrowthTask: state => state.user.receiveGrowthTask,
  receiveUserTest: state => state.user.receiveUserTest,
  useTranslator: state => state.user.useTranslator,
  blacklist: state => state.user.blacklist,
  provider: state => state.user.provider,

  openId: state => state.user.openId,

  language: state => state.app.language,
  area: state => state.app.area,

  // isMobile: state => state.app.isMobile,
  // isPad: state => state.app.isPad,
  device: state => state.app.device,
  innerBrowserApp: state => state.app.innerBrowserApp,
  alertMsg: state => state.app.alertMsg,
  countryLang: state => state.app.countryLang,
  messageNum: state => state.app.messageNum,
  homeBannerHeight: state => state.app.homeBannerHeight,
  mobileRoute: state => state.app.mobileRoute,
  showGameList: state => state.app.showGameList,
  showExplorer: state => state.app.showExplorer,
  cosRegionStr: state => state.app.cosRegionStr,
  platform: state => state.app.platform,

  //finger id
  fingerId: state => state.fingerprint.fingerId,


  // PWA
  msgToken: state => state.pwa.msgToken,

  //新手引导
  newComingGuide: state => state.app.newComingGuide
};


export default getters;
